export default __webpack_public_path__ + "static/media/diggy.f4fef502.png";